
  import { mapGetters, mapMutations } from "vuex";
  import NovaVenda from "@/components/NovaVenda.vue";
  import ContadoresStatus from "@/components/ContadoresStatus.vue";
  import FiltrosDeVenda from "@/components/FiltrosDeVenda.vue";
  import VendaBlocoDeLista from "@/components/VendaBlocoDeLista.vue";
  
  export default {
    name: "ListaVendas",
    data: () => ({
      loading: false,
      loadingMais: false, // spinner do "Carregar mais"
      hasMore: false, // indica se ainda há itens no servidor
      listaDeVendas: [],
      pagina: 1, // usada como "offset" de página
      itensPorPagina: 50, // lote maior para reduzir requisições
      total: 0,
      rejeitadas: 0,
      aprovadas: 0,
      aguardando: 0,
      emAnalise: 0,
      canceladas: 0,
      aguardandoCancelamento: 0,
      vendedores: [],
      filtros: {},
      showTopo: false, // controla exibição do botão flutuante
    }),
  
    components: {
      NovaVenda,
      ContadoresStatus,
      FiltrosDeVenda,
      VendaBlocoDeLista,
    },
  
    methods: {
      ...mapMutations("vendas", ["setListaDeVendas"]),
  
      filtrarVendas(event) {
        this.pagina = 1;
        if (event === null || Object.keys(event).length === 0) {
          this.filtros = {};
          this.getListaDeVendas();
        } else {
          this.filtros = { ...event };
          this.getListaDeVendas({ ...event });
        }
      },
  
      mergeSemDuplicados(base, lote) {
        const ids = new Set(base.map((x) => x.id));
        return base.concat(lote.filter((x) => !ids.has(x.id)));
      },
  
      // append = true quando vier do "Carregar mais"
      getListaDeVendas(filtros, append = false) {
        if (!filtros) filtros = { ...this.filtros };
        this.filtros = { ...filtros };
  
        const paginacao = {
          offset: this.pagina,
          limit: this.itensPorPagina,
        };
  
        Object.assign(filtros, paginacao);
        if (this.modo == "vendas")
          Object.assign(filtros, { id_vendedor: this.usuario.id });
  
        this.loadingMais = append;
  
        this.$http
          .post(`/vendas/filtro`, { ...filtros })
          .then((res) => {
            const lote = Array.isArray(res.data) ? res.data : [];
            this.listaDeVendas = append
              ? this.mergeSemDuplicados(this.listaDeVendas, lote)
              : lote;
  
            // Atualiza se ainda há mais registros
            if (this.total > 0) {
              this.hasMore = this.listaDeVendas.length < this.total;
            } else {
              // fallback quando total ainda não chegou
              this.hasMore = lote.length >= this.itensPorPagina;
            }
          })
          .finally(() => {
            this.loadingMais = false;
          });
      },
  
      carregarMais() {
        if (this.loadingMais || !this.hasMore) return;
        this.pagina += 1;
        this.getListaDeVendas({ ...this.filtros }, true);
      },
  
      getContadoresdeVendas() {
        let filtros = {};
        if (this.modo == "vendas")
          Object.assign(filtros, { id_vendedor: this.usuario.id });
  
        this.$http.post(`/vendas/contadores`, { ...filtros }).then((res) => {
          this.aguardando = res.data.aguardandoAnalise;
          this.aguardandoCancelamento = res.data.aguardandoCancelamento;
          this.aprovadas = res.data.aprovada;
          this.canceladas = res.data.cancelado;
          this.emAnalise = res.data.emAnalise;
          this.rejeitadas = res.data.rejeitado;
          this.total = res.data.total;
          this.vendedores = res.data.vendedores;
  
          // Recalcula hasMore quando souber o total
          this.hasMore = this.listaDeVendas.length < this.total;
        });
      },
  
      // --- Voltar ao topo ---
      onScroll() {
        const y =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0;
        this.showTopo = y > 320; // mostra o botão após 320px
      },
      scrollTopo() {
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
    },
  
    mounted() {
      this.getListaDeVendas();
      this.getContadoresdeVendas();
      window.addEventListener("scroll", this.onScroll, { passive: true });
      this.onScroll(); // inicializa estado
    },
  
    beforeDestroy() {
      window.removeEventListener("scroll", this.onScroll);
    },
  
    watch: {
      modo() {
        this.pagina = 1; // reset ao trocar de modo
        this.getContadoresdeVendas();
        this.getListaDeVendas();
        this.scrollTopo(); // sobe ao trocar de modo
      },
    },
  
    computed: {
      ...mapGetters("usuario", { usuario: "getUsuario" }),
      modo() {
        return this.$route.path.replace(/\//g, "");
      },
      listaDeVendedores() {
        const vendedores = this.listaDeVendas.map((i) =>
          (i.nome_vendedor || "").trim()
        );
        return [...new Set(vendedores)];
      },
      listaDeContratantes() {
        return this.listaDeVendas.map((i) => i.nome);
      },
    },
  };
  